// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { StartLinkAuthLinkEmailStartPostMutationRequest, StartLinkAuthLinkEmailStartPostMutationResponse, StartLinkAuthLinkEmailStartPost401, StartLinkAuthLinkEmailStartPost409, StartLinkAuthLinkEmailStartPost422, StartLinkAuthLinkEmailStartPost429 } from "../models/emailAuthController/StartLinkAuthLinkEmailStartPost.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";
import type { MutationObserverOptions, QueryClient } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { startLinkAuthLinkEmailStartPost } from "../client/startLinkAuthLinkEmailStartPost.ts";
import { useMutation } from "@tanstack/vue-query";

export const startLinkAuthLinkEmailStartPostMutationKey = () => [{ url: '/auth/link/email/start' }] as const

export type StartLinkAuthLinkEmailStartPostMutationKey = ReturnType<typeof startLinkAuthLinkEmailStartPostMutationKey>

/**
 * @description Start email linking flow for authenticated Telegram users.
 * Sends verification code to provided email address.
 * @summary Start Link
 * {@link /auth/link/email/start}
 */
export function useStartLinkAuthLinkEmailStartPost<TContext>(options: 
{
  mutation?: MutationObserverOptions<StartLinkAuthLinkEmailStartPostMutationResponse, ResponseErrorConfig<StartLinkAuthLinkEmailStartPost401 | StartLinkAuthLinkEmailStartPost409 | StartLinkAuthLinkEmailStartPost422 | StartLinkAuthLinkEmailStartPost429>, {data: MaybeRefOrGetter<StartLinkAuthLinkEmailStartPostMutationRequest>}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<StartLinkAuthLinkEmailStartPostMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions?.mutationKey ?? startLinkAuthLinkEmailStartPostMutationKey()

          return useMutation<StartLinkAuthLinkEmailStartPostMutationResponse, ResponseErrorConfig<StartLinkAuthLinkEmailStartPost401 | StartLinkAuthLinkEmailStartPost409 | StartLinkAuthLinkEmailStartPost422 | StartLinkAuthLinkEmailStartPost429>, {data: StartLinkAuthLinkEmailStartPostMutationRequest}, TContext>({
            mutationFn: async({ data }) => {
              return startLinkAuthLinkEmailStartPost(data, config)
            },
            mutationKey,
            ...mutationOptions
          }, queryClient)
      
}